// removed by extract-text-webpack-plugin


//////////////////
// WEBPACK FOOTER
// ./src/themes/default/styles/app.css
// module id = 3993
// module chunks = 3